import { Head } from 'vite-react-ssg';

export type JsonLdData = Record<string, unknown>;

/**
 * `</script>` nằm trong dữ liệu sẽ đóng thẻ script sớm và biến phần còn lại thành HTML — đó là
 * một lỗ chèn mã thật, không phải chuyện lý thuyết, vì nội dung có thể tới từ CMS. Escape `<`
 * thành `<` là cách xử lý chuẩn: JSON vẫn hợp lệ, thẻ không thể đóng sớm.
 */
function serialize(data: JsonLdData): string {
  return JSON.stringify(data).replace(/</g, '\\u003c');
}

/** `@type` là `unknown` nên phải thu hẹp trước khi ghép vào key, không ép String() bừa. */
function keyFor(data: JsonLdData, index: number): string {
  const type = data['@type'];
  return `${typeof type === 'string' ? type : 'jsonld'}-${String(index)}`;
}

export interface JsonLdProps {
  /** Nhận cả `undefined` để phía gọi viết thẳng `jsonld.breadcrumbList(...)` mà không phải lọc. */
  readonly data: readonly (JsonLdData | undefined)[];
}

export function JsonLd({ data }: JsonLdProps) {
  const blocks = data.filter((entry): entry is JsonLdData => entry !== undefined);
  if (blocks.length === 0) return null;

  return (
    <Head>
      {blocks.map((block, index) => (
        <script key={keyFor(block, index)} type="application/ld+json">
          {serialize(block)}
        </script>
      ))}
    </Head>
  );
}
